import React from 'react'

const TopStories = ({
    id = '',
    href = '',
    headline = '',
    type = '',
    images = []
}) => {
  const image = images[0] || {}

  const module = (
  <div className="cricinfo__content__item">
    <h2 className="cricinfo__sub-title">{type}</h2>
    <ul className="cricinfo__article__list"> 
      <li className="cricinfo__article__list__item">
      {
        image && image.url && 
        <div className="cricinfo__article__img"><img src={image.url} alt="placeholder" height="38" width="38"/></div>
      }
        
        {
          headline && 
          <a name="&lpos=:editorial" className="cricinfo__type__link" href={href}><div className="cricinfo__article__title">
            {headline}
          </div></a>
        }       
      </li>
    </ul>
  </div>
  )

  return id ? module : <div style={{ display: 'none' }} />
}

export default TopStories



// WEBPACK FOOTER //
// ../app/components/gamepackage/cricket/lite/TopStories.jsx